module.exports = __webpack_public_path__ + "static/img/sh.6c9f2c00.svg";